import { COLORS } from '@btime/constants'
import { range } from 'ramda'
import React from 'react'
import moment from 'moment'

import { Col, Grid } from '../../structure/Grid'
import Dropdown from '../../navigation/Dropdown'
import Icon from '../../shapes/Icon'
import IconText from '../../presentation/IconText'
import Input from '../Input'
import Link from '../../actions/Link'
import Separator from '../../helpers/Separator'
import SeparatorWrapper from '../../../../../components/helpers/SeparatorWrapper'

const SmallCalendarHeader = ({ handleMonthChange, setMonth, month }) => {
  return (
    <div>
      <Grid align="center" justify="space-between">
        <Link onClick={handleMonthChange(-1, month)}>
          <Separator weight={2}>
            <Icon name="BsChevronLeft" size="1rem" />
          </Separator>
        </Link>

        <Col flex={1}>
          <Grid gutter={0.4} align="center" justify="center">
            <Dropdown
              onChange={v => setMonth(moment(month).month(v.id).toDate())}
              options={range(0, 12).map(id => ({ id, name: moment().set('month', id).format('MMMM') }))}
              label={moment(month).format('MMMM')}
            />

            <Col width={'4rem'}>
              <Input
                limit={4}
                xsmall
                onChange={v => setMonth(moment(month).year(v).toDate())}
                value={moment(month).year()}
              />
            </Col>
          </Grid>
        </Col>

        <Link onClick={handleMonthChange(1, month)}>
          <SeparatorWrapper weight={2}>
            <Icon name="BsChevronRight" size="1rem" />
          </SeparatorWrapper>
        </Link>
      </Grid>
      <Separator weight={3} />
    </div>
  )
}

export default SmallCalendarHeader
